import React from 'react';
import { Image } from 'react-konva';

// This is from konva examples to handle URL image loading in the background
class URLImage extends React.Component {
    state = {
      image: null,
    };
    componentDidMount() {
      this.loadImage();
    }
    componentDidUpdate(oldProps) {
      if (oldProps.src !== this.props.src) {
        this.loadImage();
      }
    }
    componentWillUnmount() {
      this.image.removeEventListener('load', this.handleLoad);
    }
    loadImage() {
      // save to "this" to remove "load" handler on unmount
      this.image = new window.Image();
      this.image.src = this.props.src;
      this.image.addEventListener('load', this.handleLoad);
      if (this.props.onExtents) {
        this.props.onExtents(this.image.width, this.image.height);
      }
    }
    handleLoad = () => {
      // after setState react-konva will update canvas and redraw the layer
      // because "image" property is changed
      this.setState({
        image: this.image,
      });
      // if you keep same image object during source updates
      // you will have to update layer manually:
      // this.imageNode.getLayer().batchDraw();
    };
    render() {
      return (
        <Image
          x={this.props.x}
          offsetX={this.props.flipped ? this.props.width : 0}
          y={this.props.y}
          offsetY={this.props.flipped ? this.props.height : 0}
          width={this.props.width}
          height={this.props.height}
          image={this.state.image}
          rotation={this.props.flipped ? 180 : 0}
          id={this.props.id}
          ref={(node) => {
            this.imageNode = node;
          }}
        />
      );
    }
}

export default URLImage;
